// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"bed94dca","158":"05183aec","278":"abba5c00","299":"a68e5cdc","407":"2afc04a5","461":"cd2b76c9","520":"d7c11fbd","730":"6bf58f52","742":"c1448445","828":"06e7e203","903":"e82c0f73"}[chunkId] + ".chunk.js";
};